import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import apps from '../data/apps';
import { localized } from '../utils/localized';
import './AppShowcase.css';

function StarRating({ rating }) {
  if (!rating) return null;
  return (
    <div className="app-showcase-rating" aria-label={`${rating} stars`}>
      <span className="app-showcase-rating-star">★</span>
      <span>{rating.toFixed(1)}</span>
    </div>
  );
}

function AppShowcase() {
  const { t, locale } = useLanguage();

  return (
    <section className="app-showcase" aria-label={t('home.appsTitle')}>
      <div className="app-showcase-grid">
        {apps.map((app) => {
          const name = localized(app.name, locale);
          const genres = app.genres[locale] ?? app.genres.en;

          return (
            <article
              key={app.id}
              className={`app-showcase-card${app.comingSoon ? ' app-showcase-card--soon' : ''}`}
              style={{
                '--accent': app.accent,
                '--accent-secondary': app.accentSecondary,
              }}
            >
              <div className="app-showcase-card-glow" aria-hidden="true" />

              <div className="app-showcase-card-top">
                {app.icon ? (
                  <img
                    className="app-showcase-icon"
                    src={app.icon}
                    alt=""
                    width={72}
                    height={72}
                  />
                ) : (
                  <div
                    className="app-showcase-icon app-showcase-icon--placeholder"
                    aria-hidden="true"
                  />
                )}
                <div className="app-showcase-card-meta">
                  {app.comingSoon ? (
                    <span className="app-showcase-badge">{t('home.comingSoon')}</span>
                  ) : (
                    <span className="app-showcase-version">
                      {t('home.version')} {app.version}
                    </span>
                  )}
                  <StarRating rating={app.rating} />
                </div>
              </div>

              <h3 className="app-showcase-name">{name}</h3>
              <p className="app-showcase-tagline">
                {localized(app.tagline, locale)}
              </p>

              <div className="app-showcase-genres">
                {genres.map((genre) => (
                  <span key={genre} className="app-showcase-genre">
                    {genre}
                  </span>
                ))}
              </div>

              <div className="app-showcase-actions">
                {app.appStoreUrl ? (
                  <a
                    href={app.appStoreUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="app-showcase-btn app-showcase-btn--primary"
                  >
                    {t('home.appStore')}
                  </a>
                ) : (
                  <span className="app-showcase-btn app-showcase-btn--disabled">
                    {t('home.appStore')}
                  </span>
                )}
                <Link
                  to={`/support?app=${app.id}`}
                  className="app-showcase-btn app-showcase-btn--ghost"
                >
                  {t('home.support')}
                </Link>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default AppShowcase;
